import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";

const PatrolStaffFormPage = () => {
    const { backEnd_request } = BackMethods();

    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        firstName: "",
        fatherName: "",
        lastName: "",
        nationalId: "",
        phoneNumber: "",
        departmentName: "",
        isActive: true
    });

    const fetchStaff = async () => {
        try {
            const response = await backEnd_request.get(`/PatrolStaff/${id}`);
            setFormData(response.data);
        } catch (error) {
            console.error("Error loading staff data:", error);
        }
    };

    useEffect(() => {
        if (id) fetchStaff();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (id) {
                await backEnd_request.put(`/PatrolStaff/${id}`, formData);
            } else {
                await backEnd_request.post("/PatrolStaff", formData);
            }
            navigate("/admin/patrolstaff-management");
        } catch (error) {
            console.error("Save error:", error);
        }
    };

    return (
        <div className="container mt-4">
            <h2 className="mb-3">{id ? "تعديل موظف" : "إضافة موظف"}</h2>

            <form onSubmit={handleSubmit}>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label className="form-label">الاسم</label>
                        <input type="text" className="form-control" name="firstName"
                            value={formData.firstName} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">اسم الأب</label>
                        <input type="text" className="form-control" name="fatherName"
                            value={formData.fatherName} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">الكنية</label>
                        <input type="text" className="form-control" name="lastName"
                            value={formData.lastName} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">الرقم الوطني</label>
                        <input type="text" className="form-control" name="nationalId"
                            value={formData.nationalId} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">رقم الهاتف</label>
                        <input type="text" className="form-control" name="phoneNumber"
                            value={formData.phoneNumber} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">اسم القسم</label>
                        <input type="text" className="form-control" name="departmentName"
                            value={formData.departmentName} onChange={handleChange} required />
                    </div>

                    <div className="col-md-4 mb-3 d-flex align-items-center">
                        <label className="form-check-label me-2">فعال؟</label>
                        <input type="checkbox" className="form-check-input" name="isActive"
                            checked={formData.isActive} onChange={handleChange} />
                    </div>
                </div>

                <button className="btn btn-success mt-3" type="submit">
                    حفظ
                </button>
            </form>
        </div>
    );
};

export default PatrolStaffFormPage;
